import React, { Fragment } from 'react'
import CustomTable from '../../../../../elements/Table/CustomTable'
import BoolCell from '../../../../../elements/Table/Cells/BoolCell'
import { filterCheckedColumns, idMaker } from '../../../../../modules/Utils'
import BoolFilter from '../../../../../elements/Select/BoolFilter'
import MoneyCell from '../../../../../elements/Table/Cells/MoneyCell'
import DateTimeCell from '../../../../../elements/Table/Cells/DateTimeCell'
import checkboxHOC from 'react-table-v6/lib/hoc/selectTable'
import { Button } from 'antd'
import InvoiceModalCont from '../../../../../components/Operations/Transport/Management/FuelLines/InvoiceModal/InvoiceModalCont'

import useTitle from '../../../../../elements/Hooks/useTitle'

const CheckboxTable = checkboxHOC(CustomTable)

const ids = idMaker()
const columns = [
  { Header: 'Receipt No', accessor: 'receiptNumber' },
  { Header: 'Name', accessor: 'name' },
  { Header: 'Station Name', accessor: 'stationName' },
  { Header: 'Date', accessor: 'date', Cell: DateTimeCell },
  { Header: 'Unit', accessor: 'unit' },
  { Header: 'Vat Amount', accessor: 'vatAmount' },
  {
    Header: 'Paid',
    accessor: 'paid',
    Cell: MoneyCell,
  },
  {
    Header: 'Vat Rate',
    accessor: 'vatRate',
    Cell: MoneyCell,
    hideDefault: true,
    hideable: true,
  },
  {
    Header: 'Vat Invoice No',
    accessor: 'vatInvNum',
    hideDefault: true,
    hideable: true,
  },
  {
    Header: 'Customer Number',
    accessor: 'customerNumber',
    hideDefault: true,
    hideable: true,
  },
  {
    Header: 'Payment Method',
    accessor: 'paymentMethod',
    hideDefault: true,
    hideable: true,
  },
  { Header: 'Token Code', accessor: 'tokenCode' },
  { Header: 'Token Name', accessor: 'tokenName' },
  {
    Header: 'Vehicle Info',
    accessor: 'vehicleInfo',
    hideDefault: true,
    hideable: true,
  },
  {
    Header: 'Vat Code',
    accessor: 'vatCode',
    hideDefault: true,
    hideable: true,
  },
  {
    Header: 'Authorization Code',
    accessor: 'authorizationCode',
    hideDefault: true,
    hideable: true,
  },
  {
    Header: 'Processed',
    accessor: 'processed.state',
    filterMethod: filterCheckedColumns,
    Filter: BoolFilter,
    Cell: BoolCell,
  },
  {
    Header: 'Company',
    accessor: 'company.fn',
    hideDefault: true,
    hideable: true,
  },
  {
    Header: 'Contract',
    accessor: 'contract.code',
    hideDefault: true,
    hideable: true,
  },
  {
    Header: 'Invoice Code',
    accessor: 'processed.doc.code',
    hideDefault: true,
    hideable: true,
  },
]

const List = (props) => {
  const {
    fuelLines,
    fetch,
    fetching,
    isSelected,
    toggleSelection,
    toggleAll,
    selectAll,
    tableRef,
    selection,
    invoiceFuelLines,
  } = props
  const checkboxProps = {
    selectType: 'checkbox',
    selectAll,
    isSelected,
    toggleSelection,
    toggleAll,
  }

  useTitle(`Fuel Lines`)

  return (
    <Fragment>
      <CheckboxTable
        {...checkboxProps}
        withRef={tableRef}
        ExtraButtons={() => (
          <Fragment>
            <Button
              style={{ float: 'left', marginRight: 10 }}
              onClick={invoiceFuelLines}
              size={'small'}
              disabled={selection.length === 0}
              icon={'file-protect'}>
              Invoice
            </Button>
          </Fragment>
        )}
        columns={columns}
        data={fuelLines}
        fetch={fetch}
        fetching={fetching}
        isFilterable={true}
        show={{ extraColumns: true }}
        defaultFiltered={[
          {
            id: 'processed.state',
            value: false,
          },
        ]}
      />
      <InvoiceModalCont key={ids.next().value} {...props} type={'combo'} />
    </Fragment>
  )
}
export default (List)
